import { useState } from 'react'
import { v4 as uuidv4 } from 'uuid'

import styles from '../styles/Ingredient.module.css'

export default function Ingredient(props) {
  let classRating = styles[props.rating.toLowerCase()]

  const [visible, setVisible] = useState(false)

  function toggleVisible() {
    setVisible(!visible)
  }

  return (
    <div className={styles.ingredient_container}>
      <div className={styles.ingredient_upper}>
        <div className={styles.title_container}>
          <span className={styles.name}>{props.name}</span>
          <span className={classRating}>{props.rating}</span>
        </div>
        {props.description.short ? <p className={styles.brief}>{props.description.short}</p> : null}
      </div>
      <div className={[classRating, styles.info_container].join(' ')}>
        <div onClick={toggleVisible} className={styles.stripe}>
          <div onClick={toggleVisible} className={(visible ? [styles.close_button, classRating, styles.open_close] : [classRating, styles.open_close]).join(' ')}>
            <img style={{height: '20px', width: '20px'}} src="/plus.svg" alt={visible ? "expand" : "close"}/>
          </div>
        </div>
        <div className={(visible ? [styles.visible, styles.info_long] : [styles.invisible, styles.info_long]).join(' ')}>
          {props.description.full.length > 0 ? props.description.full.map(section => <p key={section + uuidv4()}>{section}</p>) : null}
          {props.category.length ? <p> <strong>Categories:</strong> {props.category.join(', ')}</p> : null}
          {(props.seeAlso.length) ? <p> <strong>See also:</strong> {props.seeAlso.split('\n').join(", ")}</p> : null}
        </div>
      </div>
    </div>
  )
}
